var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2846_23733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.22517 0C5.81416 0 5.48098 0.333183 5.48098 0.744186V4.27907C5.48098 4.69007 5.81416 5.02326 6.22517 5.02326C6.63617 5.02326 6.96935 4.69007 6.96935 4.27907V1.48837H14.4187V14.5116H6.96935V11.7209C6.96935 11.3099 6.63617 10.9767 6.22517 10.9767C5.81416 10.9767 5.48098 11.3099 5.48098 11.7209V15.2558C5.48098 15.6668 5.81416 16 6.22517 16H15.1629C15.5739 16 15.9071 15.6668 15.9071 15.2558V0.744186C15.9071 0.333183 15.5739 0 15.1629 0H6.22517Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50513 4.82804C9.19181 4.56204 8.72219 4.6004 8.45618 4.91371C8.19018 5.22703 8.22854 5.69666 8.54186 5.96266L10.0641 7.25498H0.837448C0.426445 7.25498 0.0932617 7.58816 0.0932617 7.99916C0.0932617 8.41016 0.426445 8.74335 0.837448 8.74335H10.065L8.54168 10.0375C8.22845 10.3036 8.19024 10.7732 8.45634 11.0865C8.72244 11.3997 9.19208 11.4379 9.50531 11.1718L12.5723 8.56632C12.7388 8.4249 12.8347 8.21748 12.8347 7.99905C12.8346 7.78061 12.7386 7.57322 12.5721 7.43185L9.50513 4.82804Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2846_23733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/LoginIcon.4a5f7e1ef6f049377fb4ac7f75335f22.svg";
export { ForwardRef as ReactComponent };